import { createTheme } from '@mui/material';

const FONT_PRIMARY = ['Montserrat', 'sans-serif'].join(',');

const FONT_SECONDARY = ['Public Sans', 'sans-serif'].join(',');
const FONT_TEXT_SECONDARY = ['Montserrat', 'sans-serif'].join(',');

const theme = createTheme({
  components: {
    MuiBackdrop: {
      styleOverrides: {
        root: {
          fontFamily: FONT_PRIMARY
          // backgroundColor: '#5e5e5ec9'
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: FONT_SECONDARY,
          textTransform: 'capitalize',
          boxShadow: `none`,
          borderRadius: '1rem',
          fontWeight: 'bold',
          fontSize: '0.8rem',
          minWidth: 'auto',
          textWrap: 'nowrap'
        },
        containedPrimary: {
          '&:hover': {
            backgroundColor: '#161616',
            color: '#fff',
            fontFamily: FONT_SECONDARY
          }
        },
        containedInfo: {
          backgroundColor: '#161616',
          color: '#fff',
          fontFamily: FONT_SECONDARY,
          '&:hover': {
            backgroundColor: '#88F231',
            color: '#fff'
          }
        }
      }
    },
    MuiTypography: {
      styleOverrides: {
        h4: {
          borderLeft: '0.6rem #88F231 solid',
          fontFamily: 'Montserrat Alternates, sans-serif',
          paddingLeft: '0.5rem',
          color: 'text.primary',
          fontWeight: 700
        },
        subtitle1: {
          fontWeight: 600,
          fontSize: '1.15rem',
          lineHeight: 1.2,
          fontFamily: '"Montserrat Alternates", sans-serif',
          color: 'text.secondary'
        },
        subtitle2: {
          fontWeight: 600,
          fontSize: '1.15rem',
          lineHeight: 1.2,
          fontFamily: 'Montserrat',
          color: 'text.secondary'
        },
        body1: {
          fontWeight: 'bold',
          lineHeight: 1.2,
          fontFamily: '"Montserrat Alternates", sans-serif',
          color: 'text.primary'
        },
        action: {
          fontSize: '1rem',
          fontWeight: 600,
          lineHeight: 1.2,
          fontFamily: '"Montserrat Alternates", sans-serif'
        },
        normal: {
          fontWeight: 500,
          // fontSize: '1rem',
          lineHeight: 1.5,
          fontFamily: '"Montserrat Alternates", sans-serif'
        },
        info: {
          fontWeight: 500,
          color: '#dcfce7',
          lineHeight: 1.5,
          fontFamily: '"Montserrat Alternates", sans-serif'
        },
        heading: {
          fontWeight: 400,
          fontSize: '24px',
          lineHeight: '40px',
          fontFamily: 'Montserrat',
          marginTop: 'auto'
        },
        superheading: {
          fontWeight: 700,
          fontSize: '32px',
          lineHeight: '60px',
          fontFamily: 'Montserrat'
        },
        modernheading: {
          fontWeight: 800,
          fontSize: '36px',
          color: '#49B02D',
          lineHeight: '60px',
          fontFamily: 'Montserrat'
        },
        subheading: {
          fontWeight: 400,
          fontSize: '18px',
          lineHeight: '24px',
          fontFamily: 'Montserrat'
        },
        subheadingbold: {
          fontWeight: 600,
          fontSize: '18px',
          lineHeight: '24px',
          fontFamily: 'Montserrat'
        },
        supportText: {
          fontWeight: 400,
          fontSize: '16px',
          lineHeight: '24px',
          fontFamily: 'Montserrat'
        },
        supportTextBold: {
          fontWeight: 700,
          fontSize: '16px',
          lineHeight: '24px',
          fontFamily: 'Montserrat'
        },
        modernSupportText: {
          fontWeight: 600,
          fontSize: '16px',
          lineHeight: '24px',
          color: '#49B02D',
          fontFamily: 'Montserrat'
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: '5px',
          '&:hover fieldset': {
            borderColor: '#88F231'
          },
          '&.Mui-focused fieldset': {
            borderColor: '#88F231'
          },
          '&.Mui-error fieldset': {
            borderColor: '#dc3545'
          },
          '& fieldset': {
            borderRadius: '6px',
            border: '2px solid #CCCCCC'
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#88F231'
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#CCCCCC'
          },
          '&.Mui-focused:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#88F231'
          }
        },
        input: {
          '&:-webkit-autofill': {
            appearance: 'none',
            WebkitBackgroundClip: 'text',
            WebkitBoxShadow: '0 0 0 100px transparent inset',
            backgroundImage: 'none !important',
            backgroundColor:
              'light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4)) !important',
            color: 'fieldtext !important'
          }
        }
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          '&.Mui-focused': {
            color: 'text.primary'
          },
          '&.Mui-error': {
            color: 'text.primary'
          }
        }
      }
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          fontFamily: FONT_TEXT_SECONDARY,
          '& fieldset': {
            borderRadius: '6px',
            border: '2px solid #e9e9e9'
          }
        },
        outlined: {
          borderRadius: '5px'
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontSize: '0.875rem',
          fontFamily: FONT_SECONDARY,
          fontWeight: 600,
          borderRadius: '8px',
          height: '24px',
          '& .MuiChip-label': {
            paddingLeft: '10px',
            paddingRight: '10px'
          },
          '& .MuiChip-icon': {
            fontSize: '1rem',
            marginLeft: '6px'
          },
          '& .MuiChip-deleteIcon': {
            fontSize: '1rem',
            marginRight: '6px',
            '&:hover': {
              color: 'inherit',
              opacity: 0.7
            }
          }
        },
        filled: {
          '&.MuiChip-colorPrimary': {
            backgroundColor: '#88F231',
            color: '#fff'
          },
          '&.MuiChip-colorSecondary': {
            backgroundColor: '#161616',
            color: '#fff'
          }
        },
        outlined: {
          borderWidth: '1.5px',
          '&.MuiChip-colorPrimary': {
            borderColor: '#88F231',
            color: '#88F231',
            '&:hover': {
              backgroundColor: 'rgba(136, 242, 49, 0.04)'
            }
          },
          '&.MuiChip-colorSecondary': {
            borderColor: '#161616',
            color: '#161616',
            '&:hover': {
              backgroundColor: 'rgba(22, 22, 22, 0.04)'
            }
          }
        }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            color: 'text.primary !important',
            fontWeight: 'bold !important'
          },
          '&:hover': {
            color: '#88F231 !important'
          }
        }
      }
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: '#88F231 !important'
        }
      }
    }
  },
  typography: {
    fontFamily: FONT_PRIMARY
  },
  palette: {
    primary: {
      main: '#88F231',
      light: '#a4ff4d',
      dark: '#6bc922',
      contrastText: '#fff'
    },
    text: {
      primary: '#161616',
      secondary: '#28282885',
      disabled: '#6c757d',
      hint: '#495057'
    },
    background: {
      default: '#ffffff',
      paper: '#f8f9fa'
    },
    error: {
      main: '#dc3545',
      light: '#e35d6a',
      dark: '#b02a37'
    },
    success: {
      main: '#88F231',
      light: '#a4ff4d',
      dark: '#6bc922'
    },
    info: {
      main: '#dcfce7',
      light: '#f4d03f',
      dark: '#c29d0b'
    }
  }
});

export default theme;
